import React from 'react'
import { kebabCase } from 'lodash'
import Helmet from 'react-helmet'
import { Link, graphql } from 'gatsby'
import { Card, Row, Col } from 'antd';
import Layout from './../../components/Layout';

const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout>
    <Row gutter={24}>
      <Helmet title={`Topics | ${title}`} />
      <Col
        lg={{
          span: 18,
          offset: 3
        }}
        md={{
          span: 18,
          offset: 3
        }}
        sm={{
          span: 24,
          offset: 0
        }}
        xs={{
          span: 24,
          offset: 0
        }}
      >
          <Card
            title={'Topics'}
          >
            <ul className="taglist">
              {group.map(tag => (
                <li key={tag.fieldValue}>
                  <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                    {tag.fieldValue} ({tag.totalCount})
                  </Link>
                </li>
              ))}
            </ul>
          </Card>
      </Col>
    </Row>
  </Layout>
)

export default TagsPage

export const tagPageQuery = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`
